// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		"busDate": "",
		"clinicId": '',
		"costAmt": '',
		"createId": '',
		"createTime": "",
		"docNum": "",
		"id": '',
		"supplierName":'',
		"list": [
			{
				"clinicId": '',
				"drugId": '',
				"drugName": "",
				"drugSpec": "",
				"id": '',
				"invId": '',
				"manuLotnum": "",
				"nullifyCnt": '',
				"nullifyDocId": '',
				"nullifyId": '',
				"nullifyState": '',
				"nullifyTime": "",
				"nullifyWaitCnt": '',
				"prodentpId": '',
				"prodentpName": "",
				"purcType": 1,
				"retnAmt": '',
				"retnCnt": '',
				"retnId": '',
				"retnPric": '',
				"saleAmt": '',
				"salePric": '',
				"unt": "",
				"purcCnt":''
			}
		],
		"nullifyB": '',
		"nullifyTime": "",
		"passingOrdersId": '',
		"passingOrdersTime": "",
		"remark": "",
		"retnTypeId": 11,
		"reviewId": '',
		"reviewTime": "",
		"saleAmt": '',
		"shedId": 1,
		"state": '',
		"supplyCandidateId": '',
		"terminalId": ""
	}
]

